import "./index.css";
import React from 'react';
import ReactDOM from 'react-dom';
import Lottery from './Lottery';

ReactDOM.render(
  <Lottery />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
